import React from "react";

const HeadingData = (options, fontStyle) => {
  const br = <br></br>;
  const heading = options?.heading ? options.heading : "";
  if (heading === "") {
    return <></>;
  } else {
    const text = heading.split("\n");
    return text ? (
      text.map((value, index) => {
        if (index != text.length) {
          return (
            <span key={index} style={heading ? fontStyle : null}>
              {value}
              <br />
            </span>
          );
        }
      })
    ) : (
      <></>
    );
  }
};
export default function Heading({ options, fontStyle, idx }) {
  const heading = options?.heading ? true : false;
  return (
    <div
      id={"heading_" + idx}
      className={"FontSIzeScale main-heading text-center"}
      style={{
        ...(heading ? fontStyle : {}),
        fontKerning: "none",
        fontFeatureSettings: '"kern" 0',
        textRendering: "geometricPrecision",
      }}
    >
      {HeadingData(options, fontStyle)}
    </div>
  );
}
